import React, { ReactNode } from "react";
import "../../Styles/RequiredMark.less";

interface FieldWrapperProps {
  label: string;
  fieldName: string;
  isRequired: boolean;
  errorMessage?: string;
  formTextColor: string;
  children: ReactNode;
}

const FieldWrapper = ({
  label,
  fieldName,
  isRequired,
  errorMessage,
  formTextColor,
  children,
}: FieldWrapperProps): JSX.Element => {
  return (
    <div className="flex flex-col items-start">
      <div className="flex flex-row">
        <label
          className={`cursor-auto font-normal mb-1 text-base leading-[18px] ${
            isRequired ? "required" : ""
          }`}
          htmlFor={fieldName}
          style={{ color: formTextColor, textShadow: "none" }}
        >
          {label}
        </label>
      </div>
      {children}
      <span
        className="leading-3 h-5 mt-1 mb-0 text-xs text-red-600"
        style={{ visibility: errorMessage ? "visible" : "hidden" }}
      >
        {errorMessage}
      </span>
    </div>
  );
};

export default FieldWrapper;
